import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine';
import style from './style.module.scss';
import clsx from 'clsx';

const allowedBlocks = ['smartfire/button'];
const templateBlocks = [
    ['smartfire/button', { text: 'Bouton 1' }],
    ['smartfire/button', { text: 'Bouton 2' }],
];

const Block = () => {
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.ChildrenBlocks
            className={clsx(style.block, isEditing && style.isEditing)}
            gutenbergEditorConfig={{
                orientation: 'vertical',
                allowedBlocks: allowedBlocks,
                template: templateBlocks,
            }}
        />
    );
};

export default defineBlock({
    Block: Block,
    setup: {
        title: 'Boutons (rangée)',
    },
});
